import { DevApiErrorType } from './dev-api-error-type'

/**
 *
 * @description 接口请求错误上报
 */
export function reportError(params: {
    /** 项目类型 */
    projType?: 'APP' | 'H5' | 'Java' | 'PHP' | 'WX_Mini'

    /** api 完整 url */
    apiUrl: string

    /** apiUrl path部分 */
    apiPath?: string

    /** 请求参数, 以query string方式给出 */
    apiParam?: string

    /** 错误类型 */
    errorType: DevApiErrorType

    /** 错误信息 */
    errorMsg?: string

    /** http 状态码, 当 {@link errorType} = {@link DevApiErrorType.HTTP_ERROR} 时必传 */
    httpCode?: number

    /** 请求耗时 毫秒 */
    costTime: number

    /** 页面url */
    pageUrl?: string
}) {
    window['sensors'].track('KbDevApiError', Object.assign({ projType: 'H5', pageUrl: window.location.href }, params))
}
